
  function activateFeaturedMedia() {
    const gallery = document.querySelector("media-gallery");
    if (!gallery) return;

    const featuredImage = gallery.querySelector("[data-featured-media]");
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!featuredImage || !viewer) return;

    const currentActive = viewer.querySelector(".product__media-item.is-active");

    if (currentActive && currentActive !== featuredImage) {
      currentActive.classList.remove("is-active");
      featuredImage.classList.add("is-active");

      const thumbnails = gallery.querySelectorAll(".thumbnail-list__item");
      thumbnails.forEach((thumb) => {
        thumb.classList.remove("is-active");
        if (thumb.dataset.target === featuredImage.dataset.mediaId) {
          thumb.classList.add("is-active");
        }
      });
    }

    // Remove listeners after first execution
    window.removeEventListener("scroll", activateFeaturedMedia);
    window.removeEventListener("touchstart", activateFeaturedMedia);
    window.removeEventListener("mousemove", activateFeaturedMedia);
  }

  // Trigger only once on first user interaction
  window.addEventListener("scroll", activateFeaturedMedia, { once: true });
  window.addEventListener("touchstart", activateFeaturedMedia, { once: true });
  window.addEventListener("mousemove", activateFeaturedMedia, { once: true });

